import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Images from "../../utils/images";
import { FaUserPen } from "react-icons/fa6";
import { DOBASEURL } from "../../utils/helper";

const ProfileActivation = () => {
  const [userData, setUserData] = useState(null);
  const [showFullComment, setShowFullComment] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const localStorageUserData = JSON.parse(localStorage.getItem("userData"));

    if (localStorageUserData) {
      setUserData(localStorageUserData);
    }
  }, [navigate]);

  if (!userData) {
    return (
      <div className="flex h-screen flex-col items-center justify-center text-lg text-gray-700">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
        <p className="mt-4">Loading, please wait...</p>
      </div>
    );
  }

  const handleEditProfile = () => {
    navigate("/editprofile");
  };

  return (
    <div className="font-jost flex min-h-screen flex-col items-center bg-gray-100 p-6 pt-24">
      <div className="flex w-full max-w-4xl items-center justify-between rounded-t-md bg-textYellow p-4 text-lg font-semibold text-white">
        <span>Congrats, {userData?.name}!</span>
        <div onClick={handleEditProfile} className="cursor-pointer">
          <FaUserPen className="text-textBlack hover:text-bgWhite" size={20} />
        </div>
      </div>

      <div className="w-full max-w-4xl rounded-b-md border border-gray-200 bg-white p-6 text-center shadow-lg">
        <h2 className="text-xl font-bold ">
          You have successfully registered!
        </h2>
        <p className="mt-2 font-medium text-gray-700">
          Your Login Details on VaisnavaMatrimony:
        </p>

        <div className="mt-4 flex flex-col items-center">
          <img
            src={
              userData?.profile?.photos?.images.length > 0
                ? DOBASEURL + userData?.profile?.photos?.images?.[0]
                : Images.DEFAULT_USER
            }
            onContextMenu={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            className="ml-2 h-[150px] w-[150px] rounded-full object-cover"
            alt=""
          />
          <p className="pt-2">{userData?.primaryEmail}</p>
          <p className="text-sm text-gray-600">
            {userData?.age} years | {userData?.maritalStatus}
          </p>
          <p className="">{userData?.phone}</p>
        </div>
        {userData?.isRejected ? (
          <div className="mt-4">
            <p className="text-sm font-semibold text-red-600">
              Rejected:{" "}
              <span className="font-normal text-gray-700">
                {userData?.rejectedComment
                  ? showFullComment
                    ? userData.rejectedComment
                    : `${userData.rejectedComment.slice(0, 60)}...`
                  : "No specific reason provided."}
              </span>
              {userData?.rejectedComment &&
                userData.rejectedComment.length > 60 && (
                  <button
                    onClick={() => setShowFullComment(!showFullComment)}
                    className="ml-2 text-blue-500 underline hover:text-blue-700"
                  >
                    {showFullComment ? "Read Less" : "Read More"}
                  </button>
                )}
            </p>

            <p className="mt-2 text-sm italic text-gray-500">
              Note: Your profile has been rejected by the admin. Please check
              the admin's comments carefully and update your profile accordingly
              by clicking the "Edit Profile" button. Make sure all the required
              details are filled properly. Once you've completed the updates,
              review everything and submit your profile for re-approval (kindly click the
              Edit Profile button — the final step i.e complete step in the Edit Profile you will see the Reapproval button. Click that to send the reactivation request to the admin.). If you
              haven't submitted it yet, please do so. After the re-approval, the
              admin will activate your account.If the reapproval verification request is not sent to the
              admin, your account cannot be activated.If you have already
              completed this step, please igonre it.
            </p>
          </div>
        ) : (
          <>
            <p className="mt-3 text-sm ">
              Your profile is awaiting approval. An admin will review it
              shortly.
            </p>
            <div className="mt-4">
              <p>Stay logged in always at VaisnavaMatrimony</p>
            </div>
            <p className="mt-2 text-sm italic text-gray-500">
              Note: Please ensure you have completed the verification step by
              clicking "Click here" or the "OK" button on the Edit Profile
              Completion page. If you haven't verified yet, kindly click the
              Edit Profile button — the final step in the Edit Profile section
              is the Verification Request to Admin. You must complete this step
              to proceed. Only after this will the admin be able to activate
              your profile. If the verification request is not sent to the
              admin, your account cannot be activated.If you have already
              completed this step, please skip it.
            </p>
          </>
        )}
        <button
          onClick={handleEditProfile}
          className="mt-4 rounded bg-yellow-500 px-4 py-2 text-white hover:bg-yellow-600"
        >
          Edit Profile
        </button>
        <div className="mt-6 text-sm text-gray-600">
          Need help? Contact our 24/7 support:
          <a
            href="mailto:support@vaisnavamatrimony.com"
            className="text-blue-600 hover:underline"
          >
            {" "}
            vaisnavamarriage@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProfileActivation;
